import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import Bottom from './Bottom';
import PaymentTypeEnum from '../../enums/PaymentTypeEnum';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentCallGate extends Component {
  componentDidMount() {
    this.props.orderStore.setPaymentMethod('1');
    // 스크립트 include
    const script = document.createElement('script');
    script.src = `${process.env.REACT_APP_CALLGATE_SCRIPT_URL}/js/viewpay_client.min.js`;
    script.async = true;
    document.body.appendChild(script);
  }

  // 결제방법 변경
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  pay = async () => {
    const { commonStore, menuStore, orderStore } = this.props;
    try {
      // 주문 임시 저장 후 토큰 발급
      orderStore.setPaymentType(PaymentTypeEnum.CALLGATE);
      const response = await api.addOrder(orderStore.orderData);

      // 결제 요청 데이터 세팅
      orderStore.setPaymentData(response.data);
    } catch (error) {
      commonStore.setError(error);
      throw error;
    } finally {
      // 결제 버튼 활성화
      orderStore.setDisablePaymentButton(false);
    }

    // 결제 호출
    const paymentData = {
      products: {
        orderNo: orderStore.paymentData.orderId,
        cmmdName: orderStore.paymentMenuName,
      },
      customer: {
        buyrName: '',
        buyrTel: orderStore.orderData.userId,
        buyrMail: 'noreply@imupos.com',
      },
      channelId: menuStore.storeData.merchantID,
      storeId: menuStore.storeData.merchantID2,
      amount: orderStore.paymentAmount.toString(),
      taxfreeAmount: orderStore.orderData.paymentTaxFree.toString(),
      taxAmount: orderStore.orderData.paymentTax.toString(),
      //cardQuota:,
      currency: 'KRW',
      language: 'KR',
      metadata: `${menuStore.storeData.companyId}|${menuStore.storeData.storeCode}`,
      redirectUrl: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/callgate?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`,
    };

    // 결제 페이지로 리다이렉트
    const response = await window.VIEWPAY.redirectViewPay(
      process.env.REACT_APP_CALLGATE_URL,
      paymentData,
      'Bearer ' + orderStore.paymentData.signData,
    );

    if (response && response.message) {
      commonStore.setSnackbar(true, response.message);
    }
  };

  render() {
    const { t, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        {menuStore.storeData.isEzwelPayUsed && (
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'일반결제'} />
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              </RadioGroup>
            </Grid>
          </Grid>
        )}
        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentCallGate);
